import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { handleTooltip } from "../../utils/handleToolTip";

function SectionContainer({ toolTip = "", rootClassName = "", customStyles = "", ...props }) {
  toolTip = handleTooltip(toolTip);
  const h5Styles = { ...styles.title, ...props.style };

  return (
    <div className={rootClassName} data-testid="section-container-root">
      <span className={"section-container " + customStyles}>
        {props.title && (
          <h5
            data-testid={props.title}
            data-for={props.toolTipId}
            data-tip={toolTip}
            style={h5Styles}
            className="dashboardModuleSectionContainer"
          >
            {props.title}
          </h5>
        )}
        <div className="dashboardModuleSectionBody" data-testid="section-container-children">
          {props.children}
        </div>
      </span>
      {props.toolTipId ? <ReactTooltip id={props.toolTipId} html={props.isToolTipHtml} /> : ""}
    </div>
  );
}

SectionContainer.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  customStyles: PropTypes.string,
  toolTip: PropTypes.string,
  style: PropTypes.object,
  rootClassName: PropTypes.string,
  isToolTipHtml: PropTypes.bool,
  toolTipId: PropTypes.string
};

const styles = {
  title: {
    padding: 0,
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 13,
    color: "#8791a0",
    textTransform: "uppercase",
    fontWeight: 700
  }
};

export default SectionContainer;
